import { render, staticRenderFns } from "./set-point.vue?vue&type=template&id=849a6450&"
import script from "./set-point.vue?vue&type=script&lang=ts&"
export * from "./set-point.vue?vue&type=script&lang=ts&"
import style0 from "./set-point.vue?vue&type=style&index=0&id=849a6450&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports